import { CmsObjectWithDefault } from '@components/Cms/types';

export type DeleteAccountPanelCmsKey =
    | 'DeleteAccountTitle'
    | 'DeleteAccountConfirmMessage'
    | 'DeleteAccountCancelButton'
    | 'DeleteAccountPopupCn';

export const DeleteAccountPanelCmsWithDefault: CmsObjectWithDefault<DeleteAccountPanelCmsKey> = {
    DeleteAccountTitle: {
        cmsId: 356692,
        defaultTranslation: 'Delete my account',
    },
    DeleteAccountConfirmMessage: {
        cmsId: 155932,
        defaultTranslation: 'Are you sure you want to delete your account?',
    },
    DeleteAccountCancelButton: {
        cmsId: 155933,
        defaultTranslation: 'Cancel',
    },
    DeleteAccountPopupCn: {
        cmsId: 356660,
        defaultTranslation: 'Please send your account deletion request to accountdeletion@agoda.com for processing',
    },
};
